import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/5/thumb-landscape.jpg"

const Post5 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">CHANEL／チェーンショルダーバッグ／18 x16 x3cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          いつかは持ちたい憧れのブランドNo.1といえば、CHANEL(シャネル）です！世界中のセレブ達から愛され、芸能人の愛用率もダントツのCHANELのバッグ。誰もが一生に一度は持ってみたいシャネルのバッグをラクサスで借りてみませんか？ラクサスではなんと4,300個以上もシャネルのバッグを取り扱っています。ぜひバッグ選びの参考にしてみてください♪
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>チェーンショルダーバッグ（マトラッセ）</h2>
          <p>やっぱりシャネルといえばマトラッセですよね。中でもやはりブラックは絶大的に人気があります！マトラッセは、ダイヤ格子の模様とチェーンショルダーが象徴的♡はじめてシャネルを手に入れるなら、断然｢黒｣がおすすめ。どんなスタイルも嬉しいくらいにランクアップしてくれます。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/5/1.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/2.jpg" alt="" />
            <span className="text-center">CHANEL／チェーンショルダーバッグ／14 x10 x6cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/3.jpg" alt="" />
            <span className="text-center">CHANEL／チェーンショルダーバッグ／25 x14 x6cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>復刻トート</h2>
          <p>キルティングとシャネルのココマークが可愛い印象のバッグ。コーデをエレガンスにまとめてくれます。ラクサスでは定番のカラー以外も多数取り揃えています♪</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/5/4.jpg" alt="" />
        </figure>
        <span className="text-center">CHANEL／復刻トートバッグ／29 x25 x15cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/5.jpg" alt="" />
            <span className="text-center">CHANEL／復刻トートバッグ／30 x24 x15cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/6.jpg" alt="" />
            <span className="text-center">CHANEL／復刻トートバッグ／29 x23 x14cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ドーヴィル</h2>
          <p>シャネルのドーヴィルはカジュアルスタイルを格上げしてくれる優れもの♡キャンバス素材で涼しげな印象にしてくれます。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/5/7.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/8.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/9.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">CHANEL／ドーヴィルMM／33 x25 x12cm</span>               
        <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">
          シャネルのバッグを見る
        </Link>
        <div className="text-max-width">
          <h2>バブルキルト</h2>
          <p>バブルキルトはもこもこした素材がコーデのワンポイントに♡カジュアルな使いやすさが魅力。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/5/10.jpg" alt="" />
        </figure>
        <span className="text-center">CHANEL／チェーンショルダーバッグ／30 x18 x10cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/11.jpg" alt="" />
            <span className="text-center">CHANEL／チェーンショルダーバッグ／28 x18 x10cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/12.jpg" alt="" />
            <span className="text-center">CHANEL／チェーンショルダーバッグ／30 x18 x8cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>チョコバー</h2>
          <p>名前の通り板チョコみたいな見た目が特徴のバッグ。現在はもう製造されておらずとても貴重なバッグです♡ちょっぴりレトロなデザインがこなれ感をプラスしてくれます。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/5/13.jpg" alt="" />
        </figure>
        <span className="text-center">CHANEL／チョコバー／28 x15 x6cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/14.jpg" alt="" />
            <span className="text-center">CHANEL／チョコバー／27 x16 x17cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/15.jpg" alt="" />
            <span className="text-center">CHANEL／チョコバー／26 x12 x4cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>カンボンライン</h2>
          <p>「カンボンライン」はブランド発祥の地パリから名付けられました。バッグの端に縫われたココマークが特徴で、キュートとエレガントの両方を叶えた大人気の定番バッグです☆</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/5/16.jpg" alt="" />
        </figure>
        <span className="text-center">CHANEL／カンボンラインラージトート／29 x25 x14cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/17.jpg" alt="" />
            <span className="text-center">CHANEL／カンボンラインボーリングバッグ／22 x12 x4cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/18.jpg" alt="" />
            <span className="text-center">CHANEL／カンボンラインミディアムトート／20 x23 x12cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">
          シャネルのバッグを見る
        </Link>
        <div className="text-max-width">
          <h2>ボーイシャネル</h2>
          <p>クールな見た目のボーイシャネルを持てば、マニッシュでエッジの効いたスタイルに早変わり。メンズライクなイテムと相性抜群でコーデをピリリと締めてくれます。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/5/19.jpg" alt="" />
        </figure>
        <span className="text-center">CHANEL／ボーイシャネル／25 x14 x7cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/20.jpg" alt="" />
            <span className="text-center">CHANEL／ボーイシャネル／24 x15 x12cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/21.jpg" alt="" />
            <span className="text-center">CHANEL／ボーイシャネル／27 x17 x6cm</span> 
          </figure>
        </div> 
        <div className="text-max-width">
          <h2>ココ・コクーン</h2>
          <p>シャネルのバッグの中でも、比較的カジュアルなのが「コココクーン」です。革とナイロンを使用していて軽量なので、使いやすいと評判の高いシリーズです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/5/22.jpg" alt="" />
        </figure>
        <span className="text-center">CHANEL／コココクーン／34 x24 x12cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/23.jpg" alt="" />
            <span className="text-center">CHANEL／コココクーン／29 x23 x15cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/24.jpg" alt="" />
            <span className="text-center">CHANEL／コココクーン／29 x25 x15cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>Vステッチ/シェブロン</h2>
          <p>特有の斜めに交差する線やV字形のステッチが特徴的。数年前よりシェブロンという名前で展開されており人気のラインです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/5/25.jpg" alt="" />
        </figure>
        <span className="text-center">CHANEL／2WAYバッグ／29 x16 x11cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/26.jpg" alt="" />
            <span className="text-center">CHANEL／Vステッチチェーンショルダーバッグ／30 x15 x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/27.jpg" alt="" />
            <span className="text-center">CHANEL／Vステッチチェーンショルダーバッグ／20 x11 x6cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ガールシャネル</h2>
          <p>なんとジャケットがそのままバッグになった遊び心満載のお茶目な「ガールシャネル」。シャネルの代表とも言えるツイード素材があしらわれたバッグは、みんなの視線を独り占めすること間違いなしです♡</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/5/28.jpg" alt="" />
        </figure>
        <span className="text-center">CHANEL／ガールシャネル／39 x35 x1cm</span>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/29.jpg" alt="" />
            <span className="text-center">CHANEL／ガールシャネル／23 x15 x7cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/5/30.jpg" alt="" />
            <span className="text-center">CHANEL／ガールシャネル／35 x26 x4cm</span> 
          </figure>
        </div>
        <div className="text-two-cloumn">
          <h2>みんなの永遠の憧れ<br className="pc"></br>「CHANEL」</h2>
          <p>コーディネートを一気にランクアップしてくれる『CHANEL』のバッグ。おしゃれ女子にとって永遠の憧れのアイテムでもありますよね♡もし憧れのシャネルのバッグでお出かけができたら……あなたはどのモデル、どのカラーを選びますか？？定番のモデルから、なかなかないレアなモデルまで、ラクサスではたくさんのシャネルのバッグを取り扱っています♪たくさんレンタルして、お気に入りのバッグを見つけてみませんか？シャネルのバッグは心をウキウキさせてくれること間違いなしです♡</p>
        </div>        
        <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">
          シャネルのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post5

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 5}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
